import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FontSizeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-font-size-single-select-edit-control",
    templateUrl: "../../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class FontSizeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {

    constructor(injector: Injector) {
        super(undefined, injector);
        this.buildData();
    }

    override buildData(): void {
        this.data = [{label: "6", value: 6},
            {label: "8", value: 8},
            {label: "10", value: 10},
            {label: "11", value: 11},
            {label: "12", value: 12},
            {label: "14", value: 14},
            {label: "16", value: 16},
            {label: "18", value: 18},
            {label: "20", value: 20},
            {label: "22", value: 22},
            {label: "24", value: 24},
            {label: "26", value: 26},
            {label: "28", value: 28},
            {label: "32", value: 32},
            {label: "40", value: 40},
            {label: "48", value: 48},
            {label: "56", value: 56},
            {label: "64", value: 64},
            {label: "72", value: 72}];
    }
}
